(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["huffy-bike-quiz"] && !Shopify.designMode) return;
  try {
    
  class HuffyBikeQuiz extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-quiz-config]').textContent);
      this.screens = Object.fromEntries([...this.querySelectorAll('[data-screen]')].map((el) => [el.dataset.screen, el]));
      this.max = parseInt(this.dataset.max, 10) || 4;
      this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      this.querySelector('[data-start]').addEventListener('click', () => this.reset(true));
      this.querySelector('[data-back]').addEventListener('click', () => this.back());
      this.querySelector('[data-retake]').addEventListener('click', () => this.reset(true));
      this.reset(false);
    }

    reset(begin) {
      this.answers = {};
      this.history = [];
      if (begin) this.ask(this.config.start);
      else this.show('intro');
    }

    show(name) {
      for (const [key, el] of Object.entries(this.screens)) el.hidden = key !== name;
      this.querySelector('.huffy-quiz__stage').hidden = name === 'result';
    }

    ask(id) {
      const q = this.config.questions[id];
      this.current = id;
      this.show('question');
      const legend = this.querySelector('.huffy-quiz__question');
      legend.textContent = q.text;
      const list = this.querySelector('.huffy-quiz__options');
      list.replaceChildren(...q.options.map((opt) => {
        const item = document.createElement('div');
        item.setAttribute('role', 'listitem');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'huffy-quiz__option';
        btn.textContent = opt.label;
        btn.addEventListener('click', () => this.answer(id, opt));
        item.append(btn);
        return item;
      }));
      // Longest path is 6 questions (adult, not-sure branch).
      const pct = Math.min(95, Math.round((this.history.length / 6) * 100) + 5);
      const bar = this.querySelector('.huffy-quiz__progress');
      bar.setAttribute('aria-valuenow', pct);
      bar.firstElementChild.style.width = `${pct}%`;
      legend.focus({ preventScroll: true });
    }

    answer(id, opt) {
      this.answers[id] = opt.id;
      this.history.push(id);
      if (opt.next) this.ask(opt.next);
      else this.finish();
    }

    back() {
      const prev = this.history.pop();
      if (!prev) return this.show('intro');
      delete this.answers[prev];
      this.ask(prev);
    }

    match() {
      const a = this.answers;
      return this.config.outcomes.find((o) =>
        o.when.some((group) => Object.entries(group).every(([q, allowed]) => allowed.includes(a[q])))
      );
    }

    async finish() {
      const outcome = this.match();
      if (!outcome) return this.reset(false);
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const shopUrl = `${root}collections/${outcome.collection}`;
      this.show('result');
      const title = this.querySelector('.huffy-quiz__result-title');
      title.textContent = outcome.title;
      this.querySelector('.huffy-quiz__result-text').textContent = outcome.text;
      const shopAll = this.querySelector('[data-shop-all]');
      shopAll.href = shopUrl;
      shopAll.textContent = outcome.shop_label;
      const list = this.querySelector('.huffy-quiz__products');
      list.replaceChildren();
      title.focus({ preventScroll: true });
      // Clear the sticky header group (tallest match; some header wrappers are empty).
      const headerH = Math.max(0, ...[...document.querySelectorAll('header, .header-section')].map((h) => h.getBoundingClientRect().height));
      const screen = this.screens.result;
      screen.style.scrollMarginTop = `${headerH + 24}px`;
      screen.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try {
        const res = await fetch(`${shopUrl}/products.json?limit=250`);
        let products = (await res.json()).products || [];
        if (outcome.tag) products = products.filter((p) => p.tags.includes(outcome.tag));
        const available = (p) => p.variants.some((v) => v.available);
        products.sort((x, y) => available(y) - available(x));
        list.replaceChildren(...products.slice(0, this.max).map((p) => this.card(p, root)));
      } catch (e) {
        list.replaceChildren();
      }
    }

    card(p, root) {
      const v = p.variants.reduce((min, x) => (parseFloat(x.price) < parseFloat(min.price) ? x : min), p.variants[0]);
      const li = document.createElement('li');
      li.className = 'huffy-quiz__product';
      const a = document.createElement('a');
      a.href = `${root}products/${p.handle}`;
      const img = p.images[0];
      if (img) {
        const el = document.createElement('img');
        el.src = `${img.src}${img.src.includes('?') ? '&' : '?'}width=600`;
        el.alt = p.title;
        el.loading = 'lazy';
        el.width = 600;
        el.height = 600;
        a.append(el);
      }
      const name = document.createElement('span');
      name.className = 'huffy-quiz__product-title';
      name.textContent = p.title;
      const price = document.createElement('span');
      price.className = 'huffy-quiz__product-price';
      price.textContent = this.money.format(parseFloat(v.price));
      if (v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)) {
        const was = document.createElement('s');
        was.textContent = this.money.format(parseFloat(v.compare_at_price));
        price.append(' ', was);
      }
      a.append(name, price);
      li.append(a);
      return li;
    }
  }
  if (!customElements.get('huffy-bike-quiz')) customElements.define('huffy-bike-quiz', HuffyBikeQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huffy-parts-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-parts-finder]').forEach(init);

    function init(root) {
      const steps = {};
      root.querySelectorAll('[data-step]').forEach(el => steps[el.dataset.step] = el);
      const state = { store: '', date: '', model: '', entry: null, index: null };
      const money = (cents) => (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });

      function show(name) {
        Object.values(steps).forEach(el => el.hidden = true);
        steps[name].hidden = false;
        steps[name].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      function error(form, msg) {
        const el = form.querySelector('[data-error]');
        if (!el) return;
        el.textContent = msg || '';
        el.hidden = !msg;
      }
      async function loadIndex() {
        if (state.index) return state.index;
        const r = await fetch(root.dataset.index, { credentials: 'omit' });
        if (!r.ok) throw new Error('index');
        state.index = await r.json();
        return state.index;
      }

      // model-type tabs
      root.querySelectorAll('.huffy-parts__type').forEach(btn => btn.addEventListener('click', () => {
        root.querySelectorAll('.huffy-parts__type').forEach(b => b.setAttribute('aria-selected', b === btn ? 'true' : 'false'));
        root.querySelectorAll('[data-type-panel]').forEach(p => p.hidden = p.dataset.typePanel !== btn.dataset.type);
      }));

      steps.purchase.addEventListener('submit', (e) => {
        e.preventDefault();
        const f = e.target;
        if (!f.store.value.trim() || !f.date.value) { f.reportValidity(); return; }
        state.store = f.store.value.trim();
        state.date = f.date.value;
        show('model');
        steps.model.querySelector('input[name=model]').focus();
      });

      steps.model.addEventListener('submit', async (e) => {
        e.preventDefault();
        const f = e.target;
        const model = f.model.value.trim();
        error(f, '');
        if (!/^\d{5}$/.test(model)) { error(f, 'Please enter the 5-digit model number.'); return; }
        const btn = f.querySelector('button[type=submit]');
        btn.disabled = true;
        try {
          const idx = await loadIndex();
          const entry = idx[model];
          if (!entry) { error(f, 'No products found. Please try again, or use the Contact Us form and include the bike name, wheel size and color.'); return; }
          state.model = model; state.entry = entry;
          const img = steps.confirm.querySelector('[data-confirm-img]');
          img.src = entry.image || '';
          img.alt = entry.name;
          steps.confirm.querySelector('[data-confirm-name]').textContent = entry.name;
          steps.confirm.querySelector('[data-confirm-model]').textContent = model;
          show('confirm');
        } catch (err) {
          error(f, 'Something went wrong. Please try again.');
        } finally {
          btn.disabled = false;
        }
      });

      root.querySelectorAll('[data-action=back-to-model]').forEach(b => b.addEventListener('click', () => show('model')));
      root.querySelector('[data-action=show-parts]').addEventListener('click', renderParts);

      async function renderParts() {
        const tbody = steps.parts.querySelector('[data-parts-rows]');
        tbody.innerHTML = '';
        error(steps.parts, '');
        show('parts');
        const rows = state.entry.parts.map(p => {
          const tr = document.createElement('tr');
          tr.dataset.sku = p.sku;
          tr.innerHTML = '<td><input type="checkbox" name="pick" value="' + p.sku + '" disabled></td>'
            + '<td>' + (p.n || '—') + '</td><td>' + esc(p.name) + '</td><td>' + p.sku + '</td>'
            + '<td class="huffy-parts__avail--no" data-avail>Checking…</td><td data-price>—</td>'
            + '<td><input type="number" name="qty" min="1" max="10" value="1" disabled></td>';
          tbody.appendChild(tr);
          return { p, tr };
        });
        await Promise.all(rows.map(async ({ p, tr }) => {
          const avail = tr.querySelector('[data-avail]');
          const price = tr.querySelector('[data-price]');
          try {
            const r = await fetch(root.dataset.root.replace(/\/$/, '') + '/products/part-' + p.sku.toLowerCase() + '.js');
            if (!r.ok) throw new Error();
            const prod = await r.json();
            const v = prod.variants[0];
            tr.dataset.variant = v.id;
            price.textContent = money(v.price);
            if (v.available) { avail.textContent = 'In stock'; avail.className = 'huffy-parts__avail--in'; }
            else { avail.textContent = 'Ships when available'; avail.className = 'huffy-parts__avail--wait'; }
            tr.querySelectorAll('input').forEach(i => i.disabled = false);
          } catch (e) {
            avail.textContent = 'Not available online';
            avail.className = 'huffy-parts__avail--no';
          }
        }));
      }

      steps.parts.addEventListener('submit', async (e) => {
        e.preventDefault();
        const picked = [...steps.parts.querySelectorAll('tr[data-variant]')].filter(tr => tr.querySelector('input[name=pick]').checked);
        if (!picked.length) { error(steps.parts, 'Select at least one part.'); return; }
        const items = picked.map(tr => ({
          id: Number(tr.dataset.variant),
          quantity: Math.max(1, Number(tr.querySelector('input[name=qty]').value) || 1),
          properties: { 'Model #': state.model, 'Purchased at': state.store, 'Purchase date': state.date, 'Part #': tr.children[1].textContent }
        }));
        const btn = steps.parts.querySelector('[data-action=add]');
        btn.disabled = true;
        try {
          const r = await fetch(root.dataset.root.replace(/\/$/, '') + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || 'Could not add to cart'); }
          window.location.href = root.dataset.cartUrl;
        } catch (err) {
          error(steps.parts, err.message || 'Could not add to cart. Please try again.');
          btn.disabled = false;
        }
      });

      // deep link: /pages/parts?model=76928 (skips straight to the model step)
      const qs = new URLSearchParams(location.search);
      if (qs.get('model')) {
        state.store = qs.get('store') || 'Unknown';
        state.date = qs.get('date') || '';
        const input = steps.model.querySelector('input[name=model]');
        input.value = qs.get('model');
        show('model');
        steps.model.requestSubmit ? steps.model.requestSubmit() : steps.model.dispatchEvent(new Event('submit', { cancelable: true }));
      }
      function esc(s) { return String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
